/* sb-dc-standnotice.js - say so when the stand the customer came for is not in
   the price yet. 2026-09-12.

   Reported (feedback item 3): opening a template from the "8'x8' Step and
   Repeat Banner with Stand" page lands in the design center at $98 with no
   stand. The customer came from a page priced with the stand, and nothing on
   screen says where it went.

   MEASURED (live, ?product=8x8-step-and-repeat-banner-with-stand):
     __dcHandle() reads the URL correctly - stand: true, repeat: true
     but api.spec.__dcProd is "custom-step-and-repeat-banner" and the price
     block shows 64 sq.ft x $1.53 = $98.00, banner only.
   So the packaged product is deliberately mapped onto the plain banner for
   designing - the board and the print file are the same thing either way - and
   the stand is meant to be re-added later. The bug the customer feels is that
   nobody tells them.

   WHAT THIS DOES: shows one line under the price block naming exactly what is
   missing and where it comes back. It does not touch the price, the cart, the
   add-ons or the print file - the amount on screen stays the true price of
   what is currently in the design.

   WHAT IT DOES NOT DO: add the stand for the customer. The editor does have an
   add-on system (window.__dcAddons / __dcLockAddons / __dcResetAddons) and
   auto-selecting from it is the better fix, but that writes money into the
   cart and the API has not been mapped yet. A wrong guess there overcharges a
   customer, so this stops at telling the truth.

   Wording follows the URL: with-stand says stand, and-red-carpet says both.

   Diagnostics: window.__dcStandNotice() */
(function () {
  'use strict';

  var ID = 'sbdc-standnotice';
  var TICK = 700, WINDOW_MS = 60000;

  var info = { shown: false, wants: [], why: '' };
  window.__dcStandNotice = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  var handle = q('product').toLowerCase();
  if (!handle) { info.why = 'no product'; return; }

  var wantsStand  = /with-stand|-stand(-|$)/.test(handle);
  var wantsCarpet = /red-carpet/.test(handle);
  if (!wantsStand && !wantsCarpet) { info.why = 'nothing packaged'; return; }
  info.wants = [wantsStand ? 'stand' : null, wantsCarpet ? 'red carpet' : null].filter(Boolean);

  function label() {
    if (wantsStand && wantsCarpet) return 'The stand and red carpet';
    if (wantsCarpet) return 'The red carpet';
    return 'The stand';
  }

  function build(after) {
    if (document.getElementById(ID)) return true;
    var box = document.createElement('div');
    box.id = ID;
    box.style.cssText = [
      'margin:10px 0 0', 'padding:10px 12px', 'border-radius:8px',
      'background:#fff6e5', 'border:1px solid #f0d49a', 'color:#6b4f16',
      'font-family:Arial,Helvetica,sans-serif', 'font-size:12.5px', 'line-height:1.5'
    ].join(';');
    box.textContent = label() + ' is not included in the price above yet - '
      + 'the amount shown is for the printed banner only. You can add it on the '
      + 'proof screen before checkout.';
    after.parentNode.insertBefore(box, after.nextSibling);
    info.shown = true;
    return true;
  }

  var t0 = Date.now();
  var t = setInterval(function () {
    if (Date.now() - t0 > WINDOW_MS) { clearInterval(t); return; }

    /* only speak up while the design really is banner-only */
    var addons = null;
    try { addons = typeof window.__dcAddons === 'function' ? window.__dcAddons() : window.__dcAddons; } catch (e) {}
    if (addons && addons.length) {
      var el = document.getElementById(ID);
      if (el) { el.remove(); info.shown = false; }
      return;
    }

    var price = document.querySelector('.price-block');
    if (!price) return;
    build(price);
  }, TICK);

  addEventListener('pagehide', function () { clearInterval(t); });
})();
